import { Plugin } from '@nuxt/types'
import { initializeAxios } from '@/utils/api'

export const plugin: Plugin = ({ $axios, redirect }): void => {
  initializeAxios($axios, redirect)
}

export default plugin